import React from 'react';

/** StatsBand.jsx — social proof strip between Hero and UseCases. Self-contained. */
const STATS = [
  { value: '85%', label: 'Admin reduction', sub: 'Average across client deployments' },
  { value: '$120K+', label: 'Annual cost savings', sub: 'Per engagement' },
  { value: '24/7', label: 'Continuous operation', sub: 'No manual oversight required' },
  { value: '4 min', label: 'Average shift-fill time', sub: 'Rostering automation' },
];

const StatsBand = () => (
  <section className="cai-sb">
    <div className="cai-sb-inner">
      {STATS.map((s) => (
        <div key={s.value} className="cai-sb-item">
          <div className="cai-sb-value">{s.value}</div>
          <div className="cai-sb-label">{s.label}</div>
          <div className="cai-sb-sub">{s.sub}</div>
        </div>
      ))}
    </div>
    <style>{`
      .cai-sb { background: #1A1A18; padding: 52px 40px; }
      .cai-sb-inner { max-width: 1100px; margin: 0 auto; display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; }
      .cai-sb-item { text-align: center; padding: 0 24px; border-right: 1px solid rgba(255,255,255,0.08); }
      .cai-sb-item:last-child { border-right: none; }
      .cai-sb-value { font-size: 42px; font-weight: 800; letter-spacing: -0.03em; color: #C0492A; line-height: 1; }
      .cai-sb-label { font-size: 15px; font-weight: 700; color: #fff; margin: 8px 0 4px; }
      .cai-sb-sub { font-size: 13px; color: #7C786E; }
      @media (max-width: 860px) {
        .cai-sb { padding: 40px 22px; }
        .cai-sb-inner { grid-template-columns: 1fr 1fr; gap: 32px 0; }
        .cai-sb-item { border-right: none; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 28px; }
        .cai-sb-item:nth-child(2n) { border-right: none; }
        .cai-sb-item:nth-last-child(-n+2) { border-bottom: none; }
        .cai-sb-value { font-size: 36px; }
      }
    `}</style>
  </section>
);

export default StatsBand;
